import React, { Component } from "react";
import $ from "jquery";
import DatePicker from "react-datepicker";
import { Doughnut, Pie, Bar } from "react-chartjs-2";
import { Line } from "react-chartjs-2";
import "react-datepicker/dist/react-datepicker.css";
import { Collapse } from "react-collapse";
import { ToastContainer, toast } from "react-toastify";

class MonthlyConversation extends Component {
  constructor() {
    super();
    this.state = {
      selectedDate: new Date(),
      totalNoOfData: 0,
      totalConversations: 0,
      totalChatDurationInMinutes: 0,
      totalTelephonyDurationInMinutes: 0,
      uniqueConversation: 0,
      averageChatDurationInSeconds: 0,
      averageTelephonyDurationInSeconds: 0,
      displayConvByDay: true,
      displayConvByLang: true,
      displayConvByDevice: true,
      displayConvBySubDevice: true,
      displayConvByBrowser: true,
      displayKeyPerformanceByHour: true,
      displayConvByChannelType: true,

      convoByClientTypeData: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [
              "rgb(110, 125, 171)",
              "rgb(156, 222, 159)",
              "rgb(255, 102, 102)",
              "rgb(14, 177, 210)",
              "rgb(106, 57, 55)",
              "rgb(204, 255, 102)",
              "rgb(247, 160, 114)",
              "rgb(191, 181, 175)",
              "rgb(244, 255, 82)",
              "rgb(95, 80, 107)",
              "rgb(105, 255, 241)",
              "rgb(155, 136, 22)",
              "rgb(242, 100, 25)",
            ],
          },
        ],
      },

      convoByDeviceSubTypeData: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [
              "rgb(110, 125, 171)",
              "rgb(156, 222, 159)",
              "rgb(255, 102, 102)",
              "rgb(14, 177, 210)",
              "rgb(106, 57, 55)",
              "rgb(204, 255, 102)",
              "rgb(247, 160, 114)",
              "rgb(191, 181, 175)",
              "rgb(244, 255, 82)",
              "rgb(95, 80, 107)",
              "rgb(105, 255, 241)",
              "rgb(155, 136, 22)",
              "rgb(242, 100, 25)",
            ],
          },
        ],
      },

      convoBydeviceType: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [
              "rgb(110, 125, 171)",
              "rgb(156, 222, 159)",
              "rgb(255, 102, 102)",
              "rgb(14, 177, 210)",
              "rgb(106, 57, 55)",
              "rgb(204, 255, 102)",
              "rgb(247, 160, 114)",
              "rgb(191, 181, 175)",
              "rgb(244, 255, 82)",
              "rgb(95, 80, 107)",
              "rgb(105, 255, 241)",
              "rgb(155, 136, 22)",
              "rgb(242, 100, 25)",
            ],
          },
        ],
      },

      // graphData:
      convoByDay: {
        labels: [],
        datasets: [
          {
            data: [],
            label: "# of Conversations",
            borderColor: "#3BA4DC",
            pointColor: "#fff",
            responsive: true,
            pointStrokeColor: "#ccc",
            pointHoverRadius: 10,
            backgroundColor: ["rgba(60,167,224,0.4)"],
            fill: true,
          },
        ],
      },

      convByLanguage: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [
              "rgb(110, 125, 171)",
              "rgb(156, 222, 159)",
              "rgb(255, 102, 102)",
              "rgb(14, 177, 210)",
              "rgb(106, 57, 55)",
              "rgb(204, 255, 102)",
              "rgb(247, 160, 114)",
              "rgb(191, 181, 175)",
              "rgb(244, 255, 82)",
              "rgb(95, 80, 107)",
              "rgb(105, 255, 241)",
              "rgb(155, 136, 22)",
              "rgb(242, 100, 25)",
            ],
          },
        ],
      },
      totalEngageTimeData: {
        labels: [],
        datasets: [
          {
            data: [],
            label: "# of Conversations",
            borderColor: "#3BA4DC",
            pointColor: "#fff",
            responsive: true,
            pointStrokeColor: "#ccc",
            pointHoverRadius: 10,
            backgroundColor: "rgba(60,167,224,0.4)",
            fill: true,
          },
        ],
      },

      convByChannelType: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: [
              "rgb(110, 125, 171)",
              "rgb(156, 222, 159)",
              "rgb(255, 102, 102)",
              "rgb(14, 177, 210)",
              "rgb(106, 57, 55)",
              "rgb(204, 255, 102)",
              "rgb(247, 160, 114)",
              "rgb(191, 181, 175)",
              "rgb(244, 255, 82)",
              "rgb(95, 80, 107)",
              "rgb(105, 255, 241)",
              "rgb(155, 136, 22)",
              "rgb(242, 100, 25)",
            ],
          },
        ],
      },

      date: null,
      month: "",
      year: "",
      startDate: "",
      endDate: "",
    };
  }

  loadData = (month, year) => {
    var MonthlyConvoController = this;

    $.ajax({
      url: "/api/monthly-analytics",
      async: false,
      method: "GET",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        month: month,
        year: year,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },

      success: function (res) {
        if (res.success === true) {
          MonthlyConvoController.state.convoByDay.labels = [];
          MonthlyConvoController.state.convoByDay.datasets[0].data = [];
          if (res.success === true && res.result.graphData.length !== 0) {
            for (var i = 0; i < res.result.graphData.length; i++) {
              MonthlyConvoController.state.convoByDay.labels.push(
                res.result.graphData[i].key
              );
              MonthlyConvoController.state.convoByDay.datasets[0].data.push(
                res.result.graphData[i].value
              );
            }
            MonthlyConvoController.state.showLoader = true;
            MonthlyConvoController.setState(MonthlyConvoController.state);
          }

          MonthlyConvoController.state.convoByClientTypeData.labels = [];
          MonthlyConvoController.state.convoByClientTypeData.datasets[0].data =
            [];
          if (res.success === true && res.result.clientTypeData.length !== 0) {
            for (var i = 0; i < res.result.clientTypeData.length; i++) {
              MonthlyConvoController.state.convoByClientTypeData.labels.push(
                res.result.clientTypeData[i].key
              );
              MonthlyConvoController.state.convoByClientTypeData.datasets[0].data.push(
                res.result.clientTypeData[i].value
              );
            }
            MonthlyConvoController.state.showLoader = true;
            MonthlyConvoController.setState(MonthlyConvoController.state);
          }

          MonthlyConvoController.state.convoByDeviceSubTypeData.labels = [];
          MonthlyConvoController.state.convoByDeviceSubTypeData.datasets[0].data =
            [];
          if (
            res.success === true &&
            res.result.deviceSubTypeData.length !== 0
          ) {
            for (var i = 0; i < res.result.deviceSubTypeData.length; i++) {
              MonthlyConvoController.state.convoByDeviceSubTypeData.labels.push(
                res.result.deviceSubTypeData[i].key
              );
              MonthlyConvoController.state.convoByDeviceSubTypeData.datasets[0].data.push(
                res.result.deviceSubTypeData[i].value
              );
            }
            MonthlyConvoController.state.showLoader = true;
            MonthlyConvoController.setState(MonthlyConvoController.state);
          }

          MonthlyConvoController.state.convoBydeviceType.labels = [];
          MonthlyConvoController.state.convoBydeviceType.datasets[0].data = [];
          if (res.success === true && res.result.deviceTypeData.length !== 0) {
            for (var i = 0; i < res.result.deviceTypeData.length; i++) {
              MonthlyConvoController.state.convoBydeviceType.labels.push(
                res.result.deviceTypeData[i].key
              );
              MonthlyConvoController.state.convoBydeviceType.datasets[0].data.push(
                res.result.deviceTypeData[i].value
              );
            }
            MonthlyConvoController.state.showLoader = true;
            MonthlyConvoController.setState(MonthlyConvoController.state);
          }

          MonthlyConvoController.state.convByLanguage.labels = [];
          MonthlyConvoController.state.convByLanguage.datasets[0].data = [];
          if (res.success === true && res.result.languageData.length !== 0) {
            for (var i = 0; i < res.result.languageData.length; i++) {
              MonthlyConvoController.state.convByLanguage.labels.push(
                res.result.languageData[i].key
              );
              MonthlyConvoController.state.convByLanguage.datasets[0].data.push(
                res.result.languageData[i].value
              );
            }
            MonthlyConvoController.state.showLoader = true;
            MonthlyConvoController.setState(MonthlyConvoController.state);
          }

          MonthlyConvoController.state.convByChannelType.labels = [];
          MonthlyConvoController.state.convByChannelType.datasets[0].data = [];
          if (res.success === true && res.result.channelTypeData.length !== 0) {
            for (var i = 0; i < res.result.channelTypeData.length; i++) {
              MonthlyConvoController.state.convByChannelType.labels.push(
                res.result.channelTypeData[i].key
              );
              MonthlyConvoController.state.convByChannelType.datasets[0].data.push(
                res.result.channelTypeData[i].value
              );
            }
            MonthlyConvoController.state.showLoader = true;
            MonthlyConvoController.setState(MonthlyConvoController.state);
          }

          MonthlyConvoController.state.totalEngageTimeData.labels = [];
          MonthlyConvoController.state.totalEngageTimeData.datasets[0].data =
            [];
          if (
            res.success === true &&
            res.result.totalEngagementTimeData.length !== 0
          ) {
            for (
              var i = 0;
              i < res.result.totalEngagementTimeData.length;
              i++
            ) {
              MonthlyConvoController.state.totalEngageTimeData.labels.push(
                res.result.totalEngagementTimeData[i].key
              );
              MonthlyConvoController.state.totalEngageTimeData.datasets[0].data.push(
                res.result.totalEngagementTimeData[i].value
              );
            }
            MonthlyConvoController.state.showLoader = true;
            MonthlyConvoController.setState(MonthlyConvoController.state);
          }
        } else {
          MonthlyConvoController.NotifyError();
        }
      },
    });
  };

  fetchMonthlyCumulativeInfoApi = (month, year) => {
    var MonthlyConvoController = this;
    $.ajax({
      url: "/api/monthly-cumulative-info",
      async: false,
      method: "GET",
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        month: month,
        year: year,
        startTime: this.state.startDate,
        endTime: this.state.endDate,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          var convoInfo = res.result;
          MonthlyConvoController.state.totalConversations =
            convoInfo.totalConversations;
          MonthlyConvoController.state.totalChatDurationInMinutes =
            convoInfo.totalChatDurationInMinutes;
          MonthlyConvoController.state.totalTelephonyDurationInMinutes =
            convoInfo.totalTelephonyDurationInMinutes;
          MonthlyConvoController.state.totalChatDurationInSeconds =
            convoInfo.totalChatDurationInSeconds;
          MonthlyConvoController.state.totalTelephonyDurationInSeconds =
            convoInfo.totalTelephonyDurationInSeconds;
          MonthlyConvoController.state.uniqueConversation =
            convoInfo.uniqueConversation;
          MonthlyConvoController.state.averageChatDurationInSeconds =
            convoInfo.averageChatDurationInSeconds;
          MonthlyConvoController.state.averageTelephonyDurationInSeconds =
            convoInfo.averageTelephonyDurationInSeconds;
        } else {
          MonthlyConvoController.NotifyError();
        }

        MonthlyConvoController.setState(MonthlyConvoController.state);
        MonthlyConvoController.loadData(MonthlyConvoController.state.month, MonthlyConvoController.state.year);
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
        MonthlyConvoController.loadData(MonthlyConvoController.state.month, MonthlyConvoController.state.year);
      },
    });
  };

  NotifyError() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        No Data found
      </b>,
      {
        position: "top-center",
      }
    );
  }
  componentDidMount() {
    var mon = new Array();
    mon[0] = "January";
    mon[1] = "February";
    mon[2] = "March";
    mon[3] = "April";
    mon[4] = "May";
    mon[5] = "June";
    mon[6] = "July";
    mon[7] = "August";
    mon[8] = "September";
    mon[9] = "October";
    mon[10] = "November";
    mon[11] = "December";
    var d = new Date();
    var month = mon[d.getMonth()];
    var year = new Date().getFullYear();
    const firstDayOfMonth = new Date(d.getFullYear(), d.getMonth(), 1).getTime();
    const lastDayOfMonth = new Date(d.getFullYear(), d.getMonth() + 1, 0).getTime();

    this.setState({
      month: month,
      year: year,
      startDate: firstDayOfMonth,
      endDate: lastDayOfMonth,
    });

    setTimeout(() => {
      this.fetchMonthlyCumulativeInfoApi(month, year);
      
    }, 300);

    var monthlyPerformController = this;
    document.addEventListener("projectChanged", function (event) {
      var mon = new Array();
      mon[0] = "January";
      mon[1] = "February";
      mon[2] = "March";
      mon[3] = "April";
      mon[4] = "May";
      mon[5] = "June";
      mon[6] = "July";
      mon[7] = "August";
      mon[8] = "September";
      mon[9] = "October";
      mon[10] = "November";
      mon[11] = "December";
      var d = new Date();
      var month = mon[d.getMonth()];
      var year = new Date().getFullYear();
      monthlyPerformController.setState({
        month: month,
        year: year,
      });
      monthlyPerformController.projectId = event.projectId;
      monthlyPerformController.loadData(month, year, event.projectId);
      monthlyPerformController.fetchMonthlyCumulativeInfoApi(month, year);
    });
  }

  handleMonChange = () => {
    var month = document.getElementById("selectMonth").value;
    var year = document.getElementById("selectYear").value;
    this.loadData(month);
    this.fetchMonthlyCumulativeInfoApi(month);
  };
  handleYearChange = () => {
    var month = document.getElementById("selectMonth").value;
    var year = document.getElementById("selectYear").value;
    this.setState({
      month: month,
      year: year,
    });
    this.loadData(month, year);
    this.fetchMonthlyCumulativeInfoApi(month, year);
  };

  onDateChange = (date) => {
    this.state.selectedDate = date;
    this.setState(this.state);
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    // Calculate start and end of the month in milliseconds
    const startOfMonth = new Date(year, date.getMonth(), 1).getTime();
    const endOfMonth = new Date(year, date.getMonth() + 1, 0).getTime();
    console.log("Start Date: and EndDate: ", startOfMonth, endOfMonth);
    this.setState({
      month: month,
      year: year,
      startDate: startOfMonth,
      endDate: endOfMonth,
    });
    this.loadData(month, year);
    this.fetchMonthlyCumulativeInfoApi(month, year);
  };

  refreshData = (id) => {
    this.loadData();
    this.fetchMonthlyCumulativeInfoApi(this.state.month, this.state.year);
  };

  resetData = () => {
    this.onDateChange(new Date());
  };

  displayConvByDay = () => {
    this.state.displayConvByDay
      ? this.setState({ displayConvByDay: false })
      : this.setState({ displayConvByDay: true });
  };

  displayConvByLang = () => {
    this.state.displayConvByLang
      ? this.setState({ displayConvByLang: false })
      : this.setState({ displayConvByLang: true });
  };

  displayConvByDevice = () => {
    this.state.displayConvByDevice
      ? this.setState({ displayConvByDevice: false })
      : this.setState({ displayConvByDevice: true });
  };

  displayConvBySubDevice = () => {
    this.state.displayConvBySubDevice
      ? this.setState({ displayConvBySubDevice: false })
      : this.setState({ displayConvBySubDevice: true });
  };

  displayKeyPerformanceByHour = () => {
    this.state.displayKeyPerformanceByHour
      ? this.setState({ displayKeyPerformanceByHour: false })
      : this.setState({ displayKeyPerformanceByHour: true });
  };

  displayConvByBrowser = () => {
    this.state.displayConvByBrowser
      ? this.setState({ displayConvByBrowser: false })
      : this.setState({ displayConvByBrowser: true });
  };

  displayConvByChannelType = () => {
    this.state.displayConvByChannelType
      ? this.setState({ displayConvByChannelType: false })
      : this.setState({ displayConvByChannelType: true });
  };

  formatTime = (timeInSeconds) => {
    let formattedTime = "";

    if (timeInSeconds <= 0) {
      formattedTime = "0 mins";
    } else {
      formattedTime += Math.floor(timeInSeconds / 60) + " mins ";
      formattedTime += (timeInSeconds % 60) + " secs";
    }

    return formattedTime;
  };

  render() {
    return (
      <div>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        <link
          rel="shortcut icon"
          type="image/png"
          href="assets/images/bot.ico"
        />
        <title>Dheeyantra | Dashboard </title>
        {/* Font Awesome Icons */}
        <link
          rel="stylesheet"
          href="plugins/font-awesome/css/font-awesome.min.css"
        />
        {/* IonIcons */}
        <link
          rel="stylesheet"
          href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
        />
        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
        {/* Theme style */}
        <link rel="stylesheet" href="dist/css/adminlte.css" />
        <link
          href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
          rel="stylesheet"
        />
        <link rel="stylesheet" href="assets/css/styles.css" />
        <link rel="stylesheet" href="assets/css/custom-style.css" />
        <div className="wrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-6">
                <h6
                  className="nav-item"
                  style={{
                    color: "#282a65",
                    marginTop: "10px",
                    marginLeft: "7px",
                  }}
                >
                  Monthly Conversation Data
                </h6>
              </div>

              <div
                className="d-flex flex-row-reverse pt-2 col-sm-6"
                style={{ backgroundColor: "#F9F9FB" }}
              >
                <button
                  className="btn action-button"
                  title="refresh"
                  onClick={this.refreshData}
                >
                  <img src="./assets/images/refresh_white_24dp.png" />
                </button>

                <button className="btn action-button" onClick={this.resetData}>
                  Reset
                </button>

                <DatePicker
                  id="date"
                  selected={this.state.selectedDate}
                  onChange={this.onDateChange}
                  dateFormat="dd/MM/yyyy"
                ></DatePicker>
              </div>
            </div>
          </div>
          {/* Custom Tabs */}
          <div className="col-12">
            {/* /.card-header */}
            <div className="card-body p-0 mb-25">
              <div className="tab-content col-12 p-0">
                <div className="tab-pane active show" id="tab_1">
                  {/* Main content */}
                  <div className="content">
                    <div className="container-fluid">
                      <div className="row">
                        <h6>
                          <img
                            src={
                              this.state.displayConvByDay
                                ? "./assets/images/downward_arrow.png"
                                : "./assets/images/rightward_arrow.png"
                            }
                            onClick={this.displayConvByDay}
                          />
                          Conversations by Day
                        </h6>
                        <div className="col-lg-12">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              gap: "13rem",
                              color: "#150d50",
                              fontWeight: "500",
                            }}
                          >
                            <p>
                              Total No Of Conversations :{" "}
                              {this.state.totalConversations}
                            </p>
                            <p>
                              Total Duration in Chat :{" "}
                              {this.formatTime(
                                this.state.totalChatDurationInSeconds
                              )}
                            </p>
                            <p>
                              Total Duration in Telephony :{" "}
                              {this.formatTime(
                                this.state.totalTelephonyDurationInSeconds
                              )}
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              gap: "15rem",
                              color: "#150d50",
                              fontWeight: "500",
                            }}
                          >
                            <p>
                              No Of Unique Conversations :{" "}
                              {this.state.totalConversations}
                            </p>
                            <p>
                              Average Duration in Chat :{" "}
                              {this.formatTime(
                                this.state.averageChatDurationInSeconds
                              )}
                            </p>
                            <p>
                              Average Duration in Telephony :{" "}
                              {this.formatTime(
                                this.state.averageTelephonyDurationInSeconds
                              )}
                            </p>
                          </div>
                          <Collapse isOpened={this.state.displayConvByDay}>
                            <div className="card filled-line-chart">
                              <div className="card-body">
                                <div className="position-relative mb-4">
                                  <Line
                                    data={this.state.convoByDay}
                                    width="1000"
                                    height="250"
                                  />
                                </div>
                              </div>
                            </div>
                          </Collapse>
                        </div>

                        <div className="col-lg-6">
                          <h6>
                            <img
                              src={
                                this.state.displayConvByLang
                                  ? "./assets/images/downward_arrow.png"
                                  : "./assets/images/rightward_arrow.png"
                              }
                              onClick={this.displayConvByLang}
                            />
                            Conversations by Language
                          </h6>
                          <br />
                          <Collapse isOpened={this.state.displayConvByLang}>
                            <div className="card monthly-conversation-chart">
                              <div className="card-body">
                                <div className="chartHeight">
                                  <Pie data={this.state.convByLanguage} />
                                </div>
                              </div>
                            </div>
                          </Collapse>
                        </div>

                        <div className="col-lg-6">
                          <h6>
                            <img
                              src={
                                this.state.displayConvByDevice
                                  ? "./assets/images/downward_arrow.png"
                                  : "./assets/images/rightward_arrow.png"
                              }
                              onClick={this.displayConvByDevice}
                            />
                            Conversations by Device
                          </h6>
                          <br />
                          <Collapse isOpened={this.state.displayConvByDevice}>
                            <div className="card monthly-conversation-chart">
                              <div className="card-body">
                                <div className="chartHeight">
                                  <Pie data={this.state.convoBydeviceType} />
                                </div>
                              </div>
                            </div>
                          </Collapse>
                        </div>

                        <div className="col-lg-6">
                          <h6>
                            <img
                              src={
                                this.state.displayConvBySubDevice
                                  ? "./assets/images/downward_arrow.png"
                                  : "./assets/images/rightward_arrow.png"
                              }
                              onClick={this.displayConvBySubDevice}
                            />
                            Conversations by Sub Device
                          </h6>
                          <br />
                          <Collapse
                            isOpened={this.state.displayConvBySubDevice}
                          >
                            <div className="card monthly-conversation-chart">
                              <div className="card-body">
                                <div className="chartHeight">
                                  <Doughnut
                                    data={this.state.convoByDeviceSubTypeData}
                                  />
                                </div>
                              </div>
                            </div>
                          </Collapse>
                        </div>

                        <div className="col-lg-6">
                          <h6>
                            <img
                              src={
                                this.state.displayConvByBrowser
                                  ? "./assets/images/downward_arrow.png"
                                  : "./assets/images/rightward_arrow.png"
                              }
                              onClick={this.displayConvByBrowser}
                            />
                            Conversations by Browser
                          </h6>
                          <br />
                          <Collapse isOpened={this.state.displayConvByBrowser}>
                            <div className="card monthly-conversation-chart">
                              <div className="card-body">
                                <div className="chartHeight">
                                  <Doughnut
                                    data={this.state.convoByClientTypeData}
                                  />
                                </div>
                              </div>
                            </div>
                          </Collapse>
                        </div>

                        <div className="col-lg-6">
                          <h6>
                            <img
                              src={
                                this.state.displayConvByChannelType
                                  ? "./assets/images/downward_arrow.png"
                                  : "./assets/images/rightward_arrow.png"
                              }
                              onClick={this.displayConvByChannelType}
                            />
                            Conversations by Channel Type
                          </h6>
                          <br />
                          <Collapse
                            isOpened={this.state.displayConvByChannelType}
                          >
                            <div className="card monthly-conversation-chart">
                              <div className="card-body">
                                <div className="chartHeight">
                                  <Pie data={this.state.convByChannelType} />
                                </div>
                              </div>
                            </div>
                          </Collapse>
                        </div>

                        <div className="col-lg-12">
                          <h6>
                            <img
                              src={
                                this.state.displayKeyPerformanceByHour
                                  ? "./assets/images/downward_arrow.png"
                                  : "./assets/images/rightward_arrow.png"
                              }
                              onClick={this.displayKeyPerformanceByHour}
                            />
                            Per Day Engagement Time(hrs)
                            <br />
                            <br />
                          </h6>
                          <Collapse
                            isOpened={this.state.displayKeyPerformanceByHour}
                          >
                            <div className="card filled-line-chart">
                              <div className="card-body">
                                <div className="position-relative mb-4">
                                  <Bar
                                    data={this.state.totalEngageTimeData}
                                    width="1000"
                                    height="250"
                                  />
                                </div>
                              </div>
                            </div>
                          </Collapse>
                          <ToastContainer className="Toast-at-center" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MonthlyConversation;



// WEBPACK FOOTER //
// ./src/projectmgmt/reports/statistics/monthlyReports/MonthlyConversation.js